export default __webpack_public_path__ + "top_scribbler.e89ca3.png";